













































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeFidelizacaoStore from '@/components/Backoffice/Store/BackofficeFidelizacaoStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import ReservaSalaStore from '@/components/ReservaSala/Store/ReservaSalaStore'
import { TipoUsuarioEnum, CancelarSolicitacaoParam, TipoOrigemEnum, RequestMessage, TipoMensagemEnum } from '@/types/_'
import { timeoutDefault, groupCollectionByField, maskHour } from '@/utils/common'
import { Triagem, ITriagem } from '@/types/implements/Triagem'
import EventBus from '@/plugins/EventBus'
import SolicitacaoCirurgiaApi from '@/Apis/Agendamento/Services/SolicitacaoCirurgiaApi'
import { permissionService } from '@/services/permission.service'

@Component
export default class ComponentModalFidelizacao extends Vue {
  $refs: {
    refConfirmarTriagem: any,
    modalContainer: HTMLElement
  }

  tipoAutorizacaoAnexo: any = {
    pedidoMedico: true,
    laudo: true,
    cotacaoOpme: true,
    laudoAnestesista: false,
    anexoOperadora: false,
    resumo: true,
  }

  tipoUsuario: TipoUsuarioEnum = TipoUsuarioEnum.Hospital

  step: number = 1
  loadHistorico: boolean = false
  loadNextStep: boolean = false
  loadCancelamento: boolean = false
  loadClose: boolean = false
  loadMensagem: boolean = false
  loadUpload: boolean = false
  loadClosePedencia: boolean = false
  loadConfirmar: boolean = false
  loadCloseBnt: boolean = false
  disableConfirmarTriagem: boolean = true

  triagem: ITriagem = new Triagem()

  mensagem: string = ''
  inputFiles: any[] = []
  reasonAcceptedDoctorSuggestion: string
  reasonSelectedKit: string
  selectedKit: string
  surgeryTechnique: string
  surgeryProtocol: string
  showSuggestionModal: boolean = false
  showAcceptProtocolModal: boolean = false
  loadingSuggestProtocol: boolean = false
  loadingAcceptProtocol: boolean = false

  showModalCategoriaDoPlanoParaFidelizacao = false
  loadingUpdateCategoriaDoPlanoParaFidelizacao = false

  get categoriaDoPlanoParaFidelizacao() {
    return this.getBackofficeGlobalStore.solicitacao.categoriaDoPlanoParaFidelizacao!
  }

  set categoriaDoPlanoParaFidelizacao(value: string) {
    this.getBackofficeGlobalStore.solicitacao.categoriaDoPlanoParaFidelizacao = value
  }

  get getDisableConfirmarTriagem() {
    return this.disableConfirmarTriagem
  }

  set getDisableConfirmarTriagem(value: boolean) {
    this.disableConfirmarTriagem = value
  }

  get loadingCloseBtn() {
    return this.loadCloseBnt
  }

  set loadingCloseBtn(val: boolean) {
    this.loadCloseBnt = val
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(val: boolean) {
    this.loadConfirmar = val
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get getStep() {
    return this.step
  }

  set getStep(value: number) {
    this.step = value
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  get loadingNextStep() {
    return this.loadNextStep
  }

  set loadingNextStep(value: boolean) {
    this.loadNextStep = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: boolean) {
    this.loadHistorico = value
  }


  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get surgerySolicitationStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }


  get backofficeFidelizacaoStore() {
    return getModule(BackofficeFidelizacaoStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getReservaSalaStore() {
    return getModule(ReservaSalaStore, this.$store)
  }

  get getTipoConfirmacao() {
    return TipoOrigemEnum.Triagem
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  get showModalFidelizacao() {
    const show = this.getBackofficeGlobalStore.modal.fidelizacao
    this.toggleHtmlOverflow(show)
    this.scrollToMensagem()

    return show
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get getPedidoMedico() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.url) {
      anexos.push({ url: this.getBackofficeGlobalStore.solicitacao.url, nomeOriginalArquivo: 'Pedido médico' })
    }
    return anexos
  }

  @Watch('showModalFidelizacao')
  showModalFidelizacaoChange(showModalFidelizacao: boolean) {
    if (
      showModalFidelizacao
      && this.canShowCategoriaDoPlanoParaFidelizacao
      && this.getBackofficeGlobalStore.solicitacao.categoriaDoPlanoParaFidelizacao === 'indefinido'
    ) {
      this.showModalCategoriaDoPlanoParaFidelizacao = true
    } else {
      this.showModalCategoriaDoPlanoParaFidelizacao = false
    }
  }

  async updateCategoriaDoPlanoParaFidelizacao(categoria: string) {
    this.loadingUpdateCategoriaDoPlanoParaFidelizacao = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const categoriaDoPlanoParaFidelizacao = categoria || this.categoriaDoPlanoParaFidelizacao!

    try {
      const res = await SolicitacaoCirurgiaApi.updateCategoriaDoPlanoParaFidelizacao(solicitacaoId, categoriaDoPlanoParaFidelizacao)

      if (res.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Categoria salva com sucesso!', icon: 'done', color: '#2E7D32' })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao alterar a categoria!', icon: 'warning', color: '#C62828' })
      }

      this.showModalCategoriaDoPlanoParaFidelizacao = false
    } finally {
      this.loadingUpdateCategoriaDoPlanoParaFidelizacao = false
    }
  }

  onSelectedKitChange(event) {
    this.selectedKit = event
  }

  surgeryTechniqueChange(event) {
    this.surgeryTechnique = event
  }

  surgeryProtocolChange(event) {
    this.surgeryProtocol = event
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  async nextStep(step: number) {
    this.loadingNextStep = true
    await timeoutDefault()

    this.getStep = step

    this.loadingNextStep = false
  }

  setStep(step) {
    this.getStep = step
  }

  async showModalCancelamento() {
    this.loadingCancelamento = true
    await timeoutDefault()
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: 'triagem',
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoTriagem(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
    this.loadingCancelamento = false
  }

  async showHistory() {
    this.loadingHistorico = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = false
  }

  async suggestProtocol() {
    try {
      this.loadingSuggestProtocol = true

      if (!this.reasonSelectedKit) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Campo de justificativa é obrigatório', icon: 'warning', color: '#C62828' })
      } else {
        const surgerySolicitationId = this.getBackofficeGlobalStore.solicitacao.id

        const protocolSuggestionData: {
          surgerySolicitationId: string,
          protocolId?: string,
          reasonSelectedKit: string,
          surgeryMaterialKitId?: string,
          surgeryTechniqueId?: string,
        } = {
          surgerySolicitationId,
          reasonSelectedKit: this.reasonSelectedKit,
        }

        if (this.surgeryProtocol) {
          protocolSuggestionData.protocolId = this.surgeryProtocol
        }

        if (this.surgeryTechnique) {
          protocolSuggestionData.surgeryTechniqueId = this.surgeryTechnique
        }

        if (this.selectedKit) {
          protocolSuggestionData.surgeryMaterialKitId = this.selectedKit
        }

        const protocolAPIResponse = await this.backofficeFidelizacaoStore.openProtocolPendency(protocolSuggestionData)

        if (protocolAPIResponse.success) {
          this.step = 1

          EventBus.$emit('setSnackbar', { show: true, text: 'Protocolo sugerido com sucesso!', icon: 'done', color: '#2E7D32' })

          await this.closeFidelizationModal()
        } else {
          EventBus.$emit('setSnackbar', { show: true, text: protocolAPIResponse.message || 'Erro ao sugerir protocolo', icon: 'warning', color: '#C62828' })
        }
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao sugerir protocolo', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingSuggestProtocol = false
    }
  }

  async acceptProtocol() {
    try {
      this.loadingAcceptProtocol = true

      if (!this.reasonAcceptedDoctorSuggestion) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Por favor, informe a razão de aceitar justificativa do médico', icon: 'warning', color: '#C62828' })
      } else {
        const surgerySolicitationId = this.getBackofficeGlobalStore.solicitacao.id

        const protocolAPIResponse = await this.backofficeFidelizacaoStore.acceptDoctorJustification({
          surgerySolicitationId,
          reason: this.reasonAcceptedDoctorSuggestion,
        })

        if (protocolAPIResponse.success) {
          this.step = 1

          EventBus.$emit('setSnackbar', { show: true, text: 'Sugestão aceita com sucesso!', icon: 'done', color: '#2E7D32' })

          await this.closeFidelizationModal()
        } else {
          EventBus.$emit('setSnackbar', { show: true, text: protocolAPIResponse.message || 'Erro ao aceitar sugestão do médico', icon: 'warning', color: '#C62828' })
        }
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao aceitar sugestão do médico', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingAcceptProtocol = false
    }
  }

  async backStep(step) {
    this.loadingCloseBtn = true
    await timeoutDefault()

    this.getReservaSalaStore.clearReservaSalasResource()
    this.getReservaSalaStore.clearReservaSalaEvent()
    this.getReservaSalaStore.clearPrecaucoesFromTasy()
    this.getStep = step
    this.loadingCloseBtn = false
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        const doc = document.getElementsByClassName('v-dialog')[0]
        if (doc) {
          doc.scrollTop = 0
        }
      }
    }
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('scroll_top_triagem')
    if (ele.length > 0) {
      ele[0].scrollTo(0, 0)
    }
  }

  async closeModalCancelamento() {
    this.getBackofficeAgendamentoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    await this.closeFidelizationModal()
  }

  async closeModal() {
    this.loadingClose = true
    this.selectedKit = ''
    this.reasonSelectedKit = ''
    this.surgeryProtocol = ''
    this.surgeryTechnique = ''
    this.reasonAcceptedDoctorSuggestion = ''

    this.getBackofficeGlobalStore.setModal({ name: 'fidelizacao', value: false })

    await this.backofficeFidelizacaoStore.loadAgendamentosMedicoSearch()

    this.loadingClose = false
  }

  async closeFidelizationModal() {
    await this.backofficeFidelizacaoStore.unblockFidelizationSurgerySolicitation(this.getBackofficeGlobalStore.solicitacao.id)

    this.selectedKit = ''
    this.surgeryTechnique = ''
    this.reasonAcceptedDoctorSuggestion = ''
    this.reasonSelectedKit = ''
    this.surgeryProtocol = ''

    this.setStep(1)
    await this.closeModal()
  }

  dialog: boolean = false
  load: boolean = false
  status: string = ''

  get loading() {
    return this.load
  }

  set loading(value: boolean) {
    this.load = value
  }

  get showModalInvalidarAssinatura() {
    return this.dialog
  }

  set showModalInvalidarAssinatura(value: boolean) {
    this.dialog = value
  }

  get canShowCategoriaDoPlanoParaFidelizacao() {
    return permissionService.hasPermission('agendamento.backoffice.protocolo.visualizarProductLine')
  }

  windowWidth: number = 0
  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })

    EventBus.$on('disabledConfirmarTriagem', (value) => { this.getDisableConfirmarTriagem = value })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
